import React, {memo} from 'react'

import {usePipelineNameOrDraft} from '../../../../../../EditPipelinePage/EditPipelinePage.hooks'
import {pipelineDraft} from '../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../hooks/pipeline'
import NameSection from '../../NameSection/NameSection'

import usePipelineNameValidationError from './hooks/usePipelineNameValidationError'

import {useAppDispatch} from 'src/hooks/react-redux'

function PipelineName() {
  const id = usePipelineId()
  const name = usePipelineNameOrDraft()
  const dispatch = useAppDispatch()
  const {handlerPipelineNameValidation, pipelineNameErrorMessage} =
    usePipelineNameValidationError(name)

  return (
    <NameSection
      name={name}
      aria-label={'Pipeline Name'}
      error={pipelineNameErrorMessage}
      onBlur={handlerPipelineNameValidation}
      onConfirmClick={handlerPipelineNameValidation}
      onNameChange={newName => dispatch(pipelineDraft.actions.setPipelineName({id, name: newName}))}
    />
  )
}

export default memo(PipelineName)
